import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import {
  LuMousePointerClick,
  LuSparkles,
  LuShapes,
  LuUsers,
  LuYoutube,
  LuSquareStack,
  LuWandSparkles,
  LuSquareMousePointer,
  LuMusic,
  LuPentagon,
  LuClapperboard,
} from "react-icons/lu";
import BetaTag from "../../common/BetaTag.jsx";
import "./_componentsNav.scss";

const CATEGORIES = [
  { key: "BasicElements", i18nKey: "basic_elements", Icon: LuSquareStack },
  { key: "SmartElements", i18nKey: "smart_elements", Icon: LuWandSparkles, beta: true },
  { key: "ClickMenu", i18nKey: "click_menu", Icon: LuSquareMousePointer },
  { key: "Assessments", i18nKey: "Interactive", Icon: LuMousePointerClick },
  { key: "Shapes", i18nKey: "shapes_panel", Icon: LuPentagon },
  { key: "LogoIntro", i18nKey: "logo_intro_panel", Icon: LuClapperboard },
  { key: "Icons", i18nKey: "icons", Icon: LuSparkles },
  { key: "Animations", i18nKey: "animations", Icon: LuShapes },
  { key: "Characters", i18nKey: "characters", Icon: LuUsers },
  { key: "Youtube", i18nKey: "youtube", Icon: LuYoutube },
  { key: "Sounds", i18nKey: "sounds_panel", Icon: LuMusic, beta: true },
];

// CLM courses (globalConfig.clm.isClm) only expose what the static
// exporter can write: images (Icons insert HotspotImages), text, click zones,
// the Animasyonlu HTML card. See common/clm.es6.
const CLM_CATEGORY_KEYS = ["BasicElements", "SmartElements", "ClickMenu", "Icons"];

// Narrow icon+label rail (Canva-style) so it takes minimal canvas width.
const ComponentsNav = ({ onCategorySelected, selectedCategory, isClm }) => {
  const [internalSelected, setInternalSelected] = useState(selectedCategory ?? null);
  const activeCategory = selectedCategory ?? internalSelected;

  useEffect(() => {
    setInternalSelected(selectedCategory ?? null);
  }, [selectedCategory]);

  const handleSelect = (key) => {
    setInternalSelected(key);
    onCategorySelected?.(key);
  };

  return (
    <div className="cmp-nav">
      {CATEGORIES.filter(({ key }) => !isClm || CLM_CATEGORY_KEYS.includes(key)).map(
        ({ key, i18nKey, Icon, beta }) => (
          <button
            key={key}
            type="button"
            className={`cmp-nav__item${activeCategory === key ? " is-active" : ""}`}
            onClick={() => handleSelect(key)}
          >
            {beta && <BetaTag />}
            <Icon size={20} />
            <span className="cmp-nav__label">{i18n.t(i18nKey) || key}</span>
          </button>
        )
      )}
    </div>
  );
};

ComponentsNav.propTypes = {
  onCategorySelected: PropTypes.func,
  selectedCategory: PropTypes.string,
  isClm: PropTypes.bool,
};

export default ComponentsNav;
